<template>
  <div class="gf_plan-item">
    <div
      class="gf_plan-item__section"
      :class="{ is_recommended: isRecommended, is_current_plan: isCurrentPlan }"
    >
      <div class="gf_plan-item__section--price">
        <div class="gf_price-save__old" :class="{'starter-disable': planInTrial || planInStarter}">
          <span class="gf_price-save__old-number">
            <template v-if="isExistsDiscount">
              ${{ basePriceOfMonthly }}
            </template>
          </span>
        </div>
        <div class="gf_price-save" v-if="planInTrial || planInTrial2022 || planInDevelopment">
          <div class="gf_price-save__number">${{ planFreePricing }}</div>
        </div>
        <div class="gf_price-save" v-else>
          <div class="gf_price-save__number" :class="{'starter-disable': planInTrial || planInStarter}" v-if="isProfessionalPlan">${{ basePriceOfMonthly }}</div>
          <div class="gf_price-save__number" :class="{'starter-disable': planInTrial || planInStarter}" v-else>${{ animatedMonthlyNumber }}<span v-if="lastPriceMonthly">{{`.${lastPriceMonthly}`}}</span></div>
          <div class="gf_price__package" :class="{'starter-disable': planInStarter}">
            <span>/</span>{{ $t("dataNewPlan.month") }}
          </div>
          
        </div>
        <template v-if="!isProfessionalPlan">
          <Promotion v-if="!yearlyMode" :promotion="planPromotionConditions(yearlyMode, planNo).appliedPromotion" :coupon="planCouponConditions(yearlyMode, planNo).appliedCoupon" />
          <div v-if="yearlyMode && newPlan" class="gf_price-info-discount">
            {{ $t('pricing.billedMonthYear', { discountMoYr: checkNumberFormat(priceOfMonthly * 12), discountSave: (discountTextOfYearly * 12).toFixed(0) }) }}
          </div>
        </template>
      </div>
      <div class="gf_plan-item__section--choose">
        <!--Current Plan-->
        <a v-if="(isCurrentPlan && trialExpire) || (isCurrentPlan && planInTrial) || (isCurrentPlan && planInStarter) || (planInTrial || planInTrial2022) || (planInDevelopment && isDevelopmentStore)"
          @click="() => {}"
          class="gf_price__button gf_price__trial__expire"
        >
          {{ currentPlanTextButton }}
        </a>
        <a v-else-if="isDevelopmentStore && !planInDevelopment"
          @click="() => {}"
          class="gf_price__button gf_price__trial__expire"
        >
          {{ txtUpgradePlan }}
        </a>
        <a v-else-if="isProfessionalPlan"
          @click="() => {}"
          class="gf_price__button gf_price__trial__expire"
        >
          {{ currentPlanTextButton }}
        </a>
        <!--Current Plan, Current plan switch to yearly, Current plan switch to Monthly-->
        <a
          v-else-if="isCurrentPlan"
          :data-url="chargeCurrentPlan"
          :yearly-mode="yearlyMode"
          :action="chargePlanActionAttribute"
          @click="onChangePlan"
          class="gf_price__button gf_price__current" :class="{ 'gf_price__current__switch_plan': (yearlyMode && notAnnually) || (!yearlyMode && !notAnnually), 'gf_price__upgrade': yearlyMode && notAnnually}"
        >
          {{ currentPlanTextButton }}
        </a>
        <!-- Upgrade Recommend, Trial Choose Plan Recommend -->
        <a
          v-else-if="isRecommended"
          class="gf_price__button gf_price__recommend"
          :data-url="chargePlan(planNo)"
          :data-plan="planNo"
          :yearly-mode="yearlyMode"
          action="update"
          @click="onChangePlan"
        >
          {{ txtUpgradePlan }}
        </a>
        <!--Pre Plan-->
        <template v-else-if="isDowngrade">
          <router-link
            :to="{ name: 'Downgrade', params: { plan: planNo, yearlyMode: yearlyMode } }"
          >
            <div
              class="gf_price__button gf_price__upgrade"
              :data-plan="planNo"
              :yearly-mode="yearlyMode"
              action="downgrade"
              @click="onChangePlan"
            >
              {{ prePlanTextButton }}
            </div>
          </router-link>
        </template>
        <a
          v-else
          :data-url="chargePlan(planNo)"
          :data-plan="planNo"
          :yearly-mode="yearlyMode"
          :action="chargePlanActionAttribute"
          @click="onChangePlan"
          class="gf_price__button gf_price__upgrade"
        >
          {{ trialExpire ? txtUpgradePlan : prePlanTextButton }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import promotion from "@/modules/Pricing/mixins/promotion";
import plan from "@/modules/Pricing/mixins/plan";
import planItem from "@/modules/Pricing/mixins/planItem";
import gsap from "gsap";
import {PLAN_NO, PLAN_TYPE, PLAN_PRICING_DEFAULT} from "@/contants/plan";

export default {
  name: "RowPricingItem",
  mixins: [promotion(), plan(), planItem()],
  data: function() {
    return {
        tweenedNumber: 0,
        planFreePricing: PLAN_PRICING_DEFAULT["trial"],
      };
  },
  computed: {
    isShowComparePrice() {
      return (this.priceOfMonthly !== this.basePriceOfMonthly) && !this.yearlyMode
    },
    animatedMonthlyNumber() {
      return this.tweenedNumber.toFixed(2).split(".").splice(0)[0]
    },
    lastPriceMonthly() {
      if (!this.priceOfMonthly) return

      const n = String(this.priceOfMonthly).split(".").splice(1)[0]
      if (n <= 0) return

      return n
    },
    newPlan() {
      return [PLAN_NO.BUILD, PLAN_NO.OPTIMIZE, PLAN_NO.ENTERPRISE].includes(this.planNo)
    },
    discountTextOfYearly() {
      const monthlyPrice = this.pricingByPlan(this.planNo, PLAN_TYPE.MONTHLY)?.basePrice
      return (monthlyPrice - this.priceOfMonthly).toFixed(1)
    },
    isDowngrade() {
      return [PLAN_NO.OPTIMIZE, PLAN_NO.ENTERPRISE, PLAN_NO.ADVANCED].includes(this.plan)
    },
    isHideBasePrice() {
      return !(this.planInTrial || this.planInTrial2022 || this.planInStarter || this.isProfessionalPlan)
    },
    isExistsDiscount() {
      return ((this.yearlyMode && this.newPlan) || this.planPromotionConditions(this.yearlyMode, this.planNo).appliedPromotion || this.planCouponConditions(this.yearlyMode, this.planNo).appliedCoupon) && this.isHideBasePrice
    },
    txtUpgradePlan() {
      if (this.isDevelopmentStore && !this.planInDevelopment) {
        return this.$t("dataNewPlan.upgradePlan", { "planMode": this.txtPlanMode })
      }
      return this.$t("dataNewPlan.upgradePlan", { "planMode": this.txtPlanMode })
    }
  },
  watch: {
    priceOfMonthly: {
      handler(newValue) {
        if (!newValue) return
        gsap.to(this.$data, { duration: 0.4, tweenedNumber: newValue, ease: "none"});
      },
      immediate: true
    }
  }
};
</script>
